/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const unitOrder = {
  unitLevelOrderHistory: {
    orderHistory: 'Historial de pedidos a nivel de unidad',
    orderId: 'Orden #',
    emptyPurchaseOrderId: 'Ninguno',
    date: 'Fecha',
    status: 'Estado',
    buyer: 'Comprador',
    unit: 'Unidad',
    total: 'Total',
    noOrders: 'No tenemos registros de pedidos coincidentes para su unidad.',
    startShopping: 'Empieza a comprar',
    sortBy: 'Ordenar por',
    sortOrders: 'Criterios de clasificación',
    purchaseOrderNumber: 'DESPUÉS #',
    startOn: 'Empezar el',
    frequency: 'Frecuencia',
    nextOrderFecha: 'Fecha de Siguiente Orden',
    notFound: 'No se han encontrado pedidos',
    //--------------------
    applyFilter: 'Aplicar',
    filterBy: 'Filtrar por',
    filterByComprador: 'Filtrar por Comprador',
    filterByCompradorLabel: 'Comprador name',
    filterByCompradorPlaceholder: 'Ingresa el nombre del comprador',
    filterByCompradorAriaLabel: 'Filtrar lista por comprador',
    filterByUnidad: 'Filtrar por Unidad',
    filterByUnidadLabel: 'Cliente',
    filterByUnidadPlaceholder: 'Introduzca el nombre de la unidad',
    filterByUnidadAriaLabel: 'Filtrar lista por unidad',
    search: 'Buscar',
    clearAll: 'Borrar todo',
    removeAppliedFilters: 'Quitar filtros',
    yourFilters: 'Sus filtros:',
    and: ' y ',
  },
  unitLevelOrderHistorySorting: {
    date: 'Fecha',
    orderNumber: 'Número de pedido',
    buyer: 'Comprador (Ascending)',
    buyerDesc: 'Comprador (Descending)',
    orgUnidad: 'Unidad (Ascending)',
    orgUnidadDesc: 'Unidad (Descending)',
  },
  unitLevelOrderDetails: {
    buyer: 'Comprador',
  },
};
